import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import Row from "react-bootstrap/Row";
import Wrapper from "../Helpers/Wrapper";
import Table from "react-bootstrap/Table";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Placeholder from 'react-bootstrap/Placeholder';

const Meetings = () => {
  const [jsonConfig, setJsonConfig] = useState();

    const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        Click here to view and download PDF.
      </Tooltip>
    );

  async function fetchConfig() {
    setJsonConfig(
      await (await fetch(`/staticData/meetingsConfig.json`)).json()
    );
  }

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <Container>
      {!jsonConfig ? 
              <Wrapper>
              <Row className="p-2 justify-content-md-center">
                <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
                  <Card.Body>
                    <Placeholder as={Card.Title} animation="glow">
                      <Placeholder xs={6}/>
                    </Placeholder>
                    <Placeholder as={Card.Text} animation="glow">
                      <Placeholder xs={7}/> <Placeholder xs={4}/> <Placeholder  xs={4}/>{' '}
                      <Placeholder xs={6} /> <Placeholder xs={8} />
                    </Placeholder>
                  </Card.Body>
                </Card>
              </Row>
              <Row className="p-2 justify-content-md-center">
                <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
                  <Card.Body>
                    <Placeholder as={Card.Title} animation="glow">
                      <Placeholder xs={6}/>
                    </Placeholder>
                    <Placeholder as={Card.Text} animation="glow">
                      <Placeholder xs={7}/> <Placeholder xs={4}/> <Placeholder  xs={4}/>{' '}
                      <Placeholder xs={6} /> <Placeholder xs={8} />
                    </Placeholder>
                  </Card.Body>
                </Card>
              </Row>
              <Row className="p-2 justify-content-md-center">
                <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
                  <Card.Body>
                    <Placeholder as={Card.Title} animation="glow">
                      <Placeholder xs={6}/>
                    </Placeholder>
                    <Placeholder as={Card.Text} animation="glow">
                      <Placeholder xs={7}/> <Placeholder xs={4}/> <Placeholder  xs={4}/>{' '}
                      <Placeholder xs={6} /> <Placeholder xs={8} />
                    </Placeholder>
                  </Card.Body>
                </Card>
              </Row>
              <Row className="p-2 justify-content-md-center" >
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Placeholder.Button variant="success" xs={2} />
              </div>
            </Row>
            </Wrapper>
      : 
      <Wrapper>
      <Row className="p-2 justify-content-md-center">
      <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
      <Card.Body>
        <Card.Title>MCMTA MEMBERSHIP MEETINGS</Card.Title>
        <Card.Text>
          <h5>Meetings Location</h5>
           <p>
             <a href={jsonConfig && jsonConfig.card1.meetingLocationLink} target="blank">
             {jsonConfig && jsonConfig.card1.meetingLocation} 
             </a>
             <br />{jsonConfig ? jsonConfig.card1.meetingRoom : undefined}
           </p>
        </Card.Text>
      </Card.Body>
      </Card>
      </Row>
      <Row className="p-2 justify-content-md-center">
      <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
      <Card.Body>
        <Card.Title>{jsonConfig ? parse(jsonConfig.card2.cardTitle) : undefined}</Card.Title>
        {jsonConfig ? 
        <Card.Subtitle>{parse(jsonConfig.card2.cardSubTitle)}</Card.Subtitle> 
        : undefined}
        
        <Card.Text>
          <br />
          <Table borderless responsive hover size="sm" className="pe-5">
            <tbody>
              {jsonConfig ? 
                jsonConfig.card2.meetingSchedule.map(sched => (
                  <tr>
                <td style={{ width: "50%", textAlign: "center" }}>
                  {sched}
                </td>
              </tr>
                )) : undefined}
            </tbody>
          </Table>
          <Table borderless responsive hover size="sm">
             <tbody>
                {jsonConfig ? 
                  jsonConfig.card2.meetingDates.map(row => (
                    <tr>
                      {row.map(meetDate => (
                        <td style={{ width: "20%", textAlign: "center" }}>
                        {meetDate}
                      </td>
                      ))}
                    </tr>
                  )) : undefined
                }
             </tbody>
           </Table>
        </Card.Text>
      </Card.Body>
      </Card>
      </Row>
      <Row className="p-2 justify-content-md-center">
      <Card className="text-center shadow-sm" style={{ width: '50rem' }}>
      <Card.Body>
        <Card.Title>{jsonConfig ? parse(jsonConfig.card3.cardTitle) : undefined}</Card.Title>
        <Card.Text>
          <p>{jsonConfig ? parse(jsonConfig.card3.cardSubTitle) : undefined}</p>
           <Table borderless responsive hover size="lg">
            <tbody>
              <tr>
                {jsonConfig ? 
                    jsonConfig.card3.row1.map(meeting => (
                    <td style={{ width: "50%", textAlign: "center" }}>
                      {meeting}
                    </td>
                )) : undefined}
                </tr>
              <tr>
                {jsonConfig ? 
                    jsonConfig.card3.row2.map(meeting => (
                    <td style={{ width: "50%", textAlign: "center" }}>
                      {meeting}
                    </td>
                )) : undefined}
                </tr>
            </tbody>
          </Table>
          {jsonConfig ? parse(jsonConfig.card3.footer) : undefined}
         </Card.Text>
      </Card.Body>
      </Card>
      </Row>
      <Row className="p-2 justify-content-md-center" >
        <div style={{ display: "flex", justifyContent: "center"}}>
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <Button 
              className="shadow-lg"
              variant="success" 
              size="sm"
              href="/dynamiccontent/meetings"
              // target="_blank"
              target="_self"
              >View PDF version</Button>
          </OverlayTrigger>
        </div>
      </Row>
      </Wrapper>
    }
    </Container>
  );
};

export default Meetings;
